import { Injectable } from '@angular/core';
import { CussService } from '../cuss.service';
import { deviceIds, Device } from 'src/embross-device-manager';
import { DeviceInt, DevicePrinterInt } from '@app/interfaces/device.interface';
import { Subject, Observable } from 'rxjs';
import { DeviceMetricsService } from '@services/devices/device-metrics.service';
import { DEVICE, DEVICE_ERROR_CODE } from '@app/enums/new-relic.enum';
@Injectable({
  providedIn: 'root',
})
export class ATBPrinterDeviceService implements DeviceInt, DevicePrinterInt {
  device: Device;
  listen$: Subject<any> = new Subject<any>();
  timeout: number = 10000;
  isComplete: boolean = false;
  private _printStart = 0;

  constructor(private cussService: CussService, private _deviceMetrics: DeviceMetricsService) {
    if (cussService.getDeviceManager()) {
      this.device = cussService.getDeviceManager().getDevice(deviceIds.ATB_PRINTER);
    }
  }

  load(pectab: string): void;
  load(pectab: string[]): void;
  load(pectab: unknown): void {
    if (this.device)
      if (typeof pectab === 'string') {
        this?.device.loadPECTAB(pectab);
      } else {
        this?.device.loadPECTABArray(pectab, 0);
      }
  }
  print(data: string): void;
  print(data: string[]): void;
  print(data: unknown): void {
    this._printStart = Date.now();
    if (this.device)
      if (typeof data === 'string') {
        this.device?.print(data, this.timeout);
      } else {
        this.device?.printArray(data, this.timeout);
      }
  }
  disable(): void {
    if (this.device) {
      this.device.OnDeviceEvent = null;
      this.device.disable();
    }
  }
  listen(): Observable<any> {
    if (this.isComplete) {
      this.listen$ = new Subject<any>();
      this.isComplete = false;
    }
    return this.listen$.asObservable();
  }

  //#region AtbPrinter
  enable(): void {
    if (this.device) {
      this.device.OnDeviceEvent = this.callback;
      this.device.enable();
    }
  }

  isOK(): boolean {
    return this.device.isDeviceOk && this.device.deviceStatus != 305;
  }
  callback = (event) => {
    console.warn('[ATB_CALLBACK]: ', event);
    switch (event.key) {
      case 'statusIsOK':
        console.warn('[statusIsOK]', event);
        break;
      case 'pectabFailed':
        this._deviceMetrics.error(DEVICE.ATB_PRINTER, DEVICE_ERROR_CODE.PECTAB_FAILED);
        this.listen$.error({ error: true, message: 'pectabFailed' });
        this.listen$ = new Subject<any>();
        break;
      case 'pectabLoaded':
      case 'pectabLoadingComplete':
        console.warn('Complete Loading...');

        break;
      case 'ticketPrinted': {
        console.warn('[ticketPrinted]', event);
        const [current, total] = event.value;
        this.listen$.next({ succes: true, message: 'ticketPrinted', value: { current, total } });

        if (current === total) {
          this._deviceMetrics.operationTime(
            DEVICE.ATB_PRINTER,
            Date.now() - this._printStart,
            true
          );
          setTimeout(() => {
            this.listen$.complete();
            this.isComplete = true;
          }, 4000);
        }
        break;
      }
      case 'ticketPrintingComplete':
        console.warn('[ticketPrintingComplete]', event);
        break;
      case 'ticketFailed':
        console.warn('[ticketFailed]', event);
        this._deviceMetrics.error(DEVICE.ATB_PRINTER, DEVICE_ERROR_CODE.TICKET_FAILED);
        this.listen$.error({ error: true, message: 'ticketFailed' });
        this.listen$ = new Subject<any>();
        break;
      case 'statusChange':
        if (event.value[0] > 300 && event.value[0] < 310) {
          this._deviceMetrics.disconnected(DEVICE.ATB_PRINTER, event.value[0]);
        }
        break;
      default:
        console.warn('[callbackPrinter_async]', event);
        break;
    }
  };
}
